import { Flex, FlexItem } from 'shared_DEPRECATED/components/Flex';
import { HotjarSuppression } from 'shared_DEPRECATED/components/Hotjar';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';
import { useCopyToClipboard } from 'shared_DEPRECATED/hooks';

import { ButtonIcon } from 'shared/components/Button';
import { Typography } from 'shared/components/Typography';

type TParticipantCopyId = {
  id: string;
};

export const ParticipantCopyId = ({ id }: TParticipantCopyId) => {
  const copyTextToClipboard = useCopyToClipboard({
    clipboardText: id,
    clipboardTextName: 'user ID',
  });

  return (
    <>
      {id ? (
        <Flex justifyContent="space-between">
          <FlexItem flexShrink={0}>
            <Icon width="16px" height="16px" name={iconNames.userId} />
          </FlexItem>
          <Spacer size="xsm" />
          <Typography type="small" cropped={true} color="gray">
            <HotjarSuppression as="span">{id}</HotjarSuppression>
          </Typography>
          <FlexItem>
            <ButtonIcon
              aria-label="copy id"
              onClick={copyTextToClipboard}
              variant="ghost"
              size="sm"
            >
              <Icon name={iconNames.copy} stroke="var(--fgSecondary)" />
            </ButtonIcon>
          </FlexItem>
        </Flex>
      ) : null}
    </>
  );
};
